module.exports = __webpack_public_path__ + "img/help_img_hover.b14ed12c.png";